export default {
  // Navigation
  'nav.home': 'الرئيسية',
  'nav.solutions': 'الحلول',
  'nav.features': 'المميزات',
  'nav.pricing': 'الأسعار',
  'nav.login': 'تسجيل الدخول',
  'nav.getStarted': 'ابدأ الآن',
  
  // Hero Section
  'hero.title': 'منصة تسريع الألعاب العالمية',
  'hero.subtitle': 'حلول شبكية شاملة لناشري الألعاب في الخارج',
  'hero.description': 'نستفيد من شبكات التسريع متعددة العقد والجدولة الديناميكية للحركة والحماية الأمنية الشاملة لتقديم خدمات شبكية متكاملة للتنزيل والتفاعل والحماية',
  'hero.cta.primary': 'ابدأ التجربة المجانية',
  'hero.cta.secondary': 'عرض توضيحي',
  
  // Stats
  'stats.latency': 'متوسط تقليل التأخير',
  'stats.conversion': 'زيادة معدل التثبيت',
  'stats.uptime': 'وقت تشغيل الخدمة',
  'stats.nodes': 'عقد التسريع العالمية',
  
  // Solutions
  'solutions.title': 'حلول شاملة',
  'solutions.subtitle': 'معالجة ثلاث نقاط ألم أساسية في عمليات الألعاب العالمية',
  
  'solutions.download.title': 'تسريع التنزيل الذكي',
  'solutions.download.desc': 'شبكة CDN متعددة العقد تضمن تنزيلات مستقرة لحزم الألعاب في الأسواق الناشئة، مما يزيد معدلات تحويل التثبيت بنسبة 18%',
  'solutions.download.feature1': 'تقنية استئناف نقطة التوقف',
  'solutions.download.feature2': 'اختيار المسار الذكي',
  'solutions.download.feature3': 'التنزيل متعدد المصادر',
  
  'solutions.interaction.title': 'تفاعل منخفض التأخير',
  'solutions.interaction.desc': 'تحسين التأخير بالمللي ثانية للمعارك عبر الخوادم والبطولات العالمية، مما يعزز تجربة الألعاب التنافسية',
  'solutions.interaction.feature1': 'جدولة حركة المرور الديناميكية',
  'solutions.interaction.feature2': 'تحسين البروتوكول',
  'solutions.interaction.feature3': 'المراقبة في الوقت الفعلي',
  
  'solutions.security.title': 'حماية أمنية شاملة',
  'solutions.security.desc': 'آليات دفاع متقدمة ضد هجمات DDoS و CC، تضمن توفر الخادم بنسبة 99.99%',
  'solutions.security.feature1': 'كشف التهديدات الذكي',
  'solutions.security.feature2': 'نظام دفاع متعدد الطبقات',
  'solutions.security.feature3': 'مراقبة أمنية على مدار الساعة',
  
  // Features
  'features.title': 'مميزات المنصة',
  'features.subtitle': 'قدرات قوية تدفع نجاحك في الألعاب العالمية',
  
  'features.network.title': 'شبكة تسريع عالمية',
  'features.network.desc': 'أكثر من 500 عقدة عبر 6 قارات، تغطي جميع أسواق الألعاب الرئيسية',
  
  'features.analytics.title': 'لوحة تحليلات في الوقت الفعلي',
  'features.analytics.desc': 'رؤى بيانات شاملة لأداء الشبكة وتجربة المستخدم',
  
  'features.api.title': 'واجهة برمجة صديقة للمطورين',
  'features.api.desc': 'تكامل سهل مع RESTful API ووثائق شاملة',
  
  'features.support.title': 'دعم فني على مدار الساعة',
  'features.support.desc': 'فريق دعم مخصص متاح على مدار الساعة',
  
  'features.scalability.title': 'بنية تحتية قابلة للتوسع التلقائي',
  'features.scalability.desc': 'تعديل الموارد تلقائياً بناءً على متطلبات حركة المرور',
  
  'features.compliance.title': 'الامتثال العالمي',
  'features.compliance.desc': 'يلبي لوائح حماية البيانات عبر مناطق مختلفة',
  
  // Pricing
  'pricing.title': 'خطط أسعار مرنة',
  'pricing.subtitle': 'اختر الخطة المثالية لأعمال الألعاب الخاصة بك',
  
  'pricing.starter.name': 'المبتدئ',
  'pricing.starter.price': '$299',
  'pricing.starter.period': '/شهر',
  'pricing.starter.desc': 'مثالي لمطوري الألعاب المستقلين',
  'pricing.starter.feature1': 'حتى 100 جيجابايت عرض النطاق',
  'pricing.starter.feature2': '50 عقدة تسريع',
  'pricing.starter.feature3': 'حماية DDoS أساسية',
  'pricing.starter.feature4': 'دعم البريد الإلكتروني',
  'pricing.starter.feature5': 'الوصول إلى API',
  
  'pricing.professional.name': 'المحترف',
  'pricing.professional.price': '$999',
  'pricing.professional.period': '/شهر',
  'pricing.professional.desc': 'مثالي لاستوديوهات الألعاب النامية',
  'pricing.professional.feature1': 'حتى 1 تيرابايت عرض النطاق',
  'pricing.professional.feature2': '200 عقدة تسريع',
  'pricing.professional.feature3': 'حماية DDoS متقدمة',
  'pricing.professional.feature4': 'دعم ذو أولوية',
  'pricing.professional.feature5': 'تحليلات مخصصة',
  'pricing.professional.feature6': 'مدير حساب مخصص',
  
  'pricing.enterprise.name': 'المؤسسات',
  'pricing.enterprise.price': 'مخصص',
  'pricing.enterprise.period': '',
  'pricing.enterprise.desc': 'لناشري الألعاب على نطاق واسع',
  'pricing.enterprise.feature1': 'عرض نطاق غير محدود',
  'pricing.enterprise.feature2': 'أكثر من 500 عقدة تسريع',
  'pricing.enterprise.feature3': 'أمان على مستوى المؤسسات',
  'pricing.enterprise.feature4': 'دعم مخصص على مدار الساعة',
  'pricing.enterprise.feature5': 'تكامل مخصص',
  'pricing.enterprise.feature6': 'ضمان SLA',
  'pricing.enterprise.feature7': 'حل العلامة البيضاء',
  
  'pricing.cta': 'اختر الخطة',
  'pricing.popular': 'الأكثر شعبية',
  
  // CTA Section
  'cta.title': 'هل أنت مستعد لتسريع نجاحك في الألعاب العالمية؟',
  'cta.description': 'انضم إلى مئات ناشري الألعاب حول العالم الذين يثقون في Elephant Tech لبنيتهم التحتية للشبكة',
  'cta.button': 'ابدأ تجربتك المجانية',
  
  // Footer
  'footer.product': 'المنتج',
  'footer.solutions': 'الحلول',
  'footer.features': 'المميزات',
  'footer.pricing': 'الأسعار',
  'footer.documentation': 'الوثائق',
  
  'footer.company': 'الشركة',
  'footer.about': 'من نحن',
  'footer.careers': 'الوظائف',
  'footer.blog': 'المدونة',
  'footer.press': 'الصحافة',
  
  'footer.resources': 'الموارد',
  'footer.help': 'مركز المساعدة',
  'footer.api': 'مرجع API',
  'footer.status': 'حالة النظام',
  'footer.security': 'الأمان',
  
  'footer.legal': 'قانوني',
  'footer.privacy': 'سياسة الخصوصية',
  'footer.terms': 'شروط الخدمة',
  'footer.compliance': 'الامتثال',
  
  'footer.copyright': '© 2024 Elephant Tech Limited. جميع الحقوق محفوظة.',
  'footer.poweredBy': 'مدعوم من Readdy',
  
  // Login Page
  'login.title': 'مرحباً بعودتك',
  'login.subtitle': 'سجل الدخول إلى حساب مؤسستك',
  'login.email': 'البريد الإلكتروني',
  'login.password': 'كلمة المرور',
  'login.remember': 'تذكرني',
  'login.forgot': 'نسيت كلمة المرور؟',
  'login.submit': 'تسجيل الدخول',
  'login.noAccount': 'ليس لديك حساب؟',
  'login.contact': 'اتصل بالمبيعات',
  'login.or': 'أو تابع مع',
  'login.google': 'جوجل',
  'login.microsoft': 'مايكروسوفت',
  'login.selectedPlan': 'الخطة المختارة',
};
